import React from 'react';
import Navbar from './Navbar';
import { useProcessing } from '../contexts/ProcessingContext';
import ProcessingModal from './ProcessingModal';

export default function Layout({ children }) {
  const { backgroundSession, isModalOpen, openModal, closeModal, clearBackground } = useProcessing();

  const handleOpenProcessingModal = () => {
    openModal();
  };

  const handleCloseModal = () => {
    closeModal();
  };

  const handleCancel = () => {
    clearBackground();
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar onOpenProcessingModal={handleOpenProcessingModal} />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
      
      {backgroundSession && (
        <ProcessingModal
          isOpen={isModalOpen}
          status="processing"
          sessionId={backgroundSession}
          onClose={handleCloseModal}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
}
